import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Breadcrumb, Card, Typography } from 'antd'
import { path } from 'src/libs'
import {
  FormSkeleton,
  FormWebPage,
} from 'src/pages/ib/adMaterials/webSitePages/components'
import {
  BASE_URL,
  loadWebSiteById,
  updateWebSiteFx,
} from 'src/pages/ib/adMaterials/webSitePages/model'
import { useWebPageCurrent } from 'src/pages/ib/adMaterials/webSitePages/hooks'
import { WebSitePayload } from 'src/pages/ib/adMaterials/webSitePages/types'
import { useUnit } from 'effector-react'

export const EditWebSitePage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const webSiteCurrent = useWebPageCurrent()
  const { Title, Text } = Typography

  useEffect(() => {
    if (!id) return
    loadWebSiteById({ id })
  }, [id])

  const title = webSiteCurrent?.title
  const link = webSiteCurrent?.link
  const isVisible = webSiteCurrent?.isVisible

  const handleSubmit = async (values: WebSitePayload) => {
    try {
      await updateWebSiteFx({
        url: `${BASE_URL}/${id}`,
        body: { ...values },
      })
      navigate(path.ib.ad.website_pages.entry())
    } catch (error) {
      console.error(error)
    }
  }
  const loadingUpdate = useUnit(updateWebSiteFx.pending)
  return (
    <Card>
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                }}
                onClick={() => navigate(path.ib.ad.website_pages.entry())}
              >
                WebSite Pages
              </Text>
            ),
          },
          {
            title: <Text type="secondary">Update WebSite Page Link</Text>,
          },
        ]}
        style={{ marginBottom: 24 }}
      />
      <Title level={4}>Update WebSite Page Link</Title>
      {webSiteCurrent ? (
        <FormWebPage
          initialValues={{ isVisible, link, title }}
          onSubmit={handleSubmit}
          loading={loadingUpdate}
        />
      ) : (
        <FormSkeleton />
      )}
    </Card>
  )
}
